import React from 'react';
import { Card, Descriptions, Typography } from 'antd';
import { deploymentConfiguration, sourceWorkerHeartbeatData } from '../utils';
import { SourceWorkerConfiguration } from './SourceWorkerConfiguration';

export const SourceWorkers = ({ cloudAccountData, error }) => {
    let heartbeatData = sourceWorkerHeartbeatData(cloudAccountData?.appliance);
    let configuration = deploymentConfiguration(cloudAccountData?.appliance);
    let cardTitle =
        cloudAccountData?.type === 'vsphere_offline_replicas'
            ? 'Primary Site RMS Appliance Configuration:'
            : 'Source Worker Appliance(s):';

    return (
        configuration.length > 0 && (
            <SourceWorkerConfiguration
                appliance={cloudAccountData.appliance}
                configuration={configuration}
                cardTitle={cardTitle}
                heartbeatData={heartbeatData}
                error={error}
            />
        )
    );
};
